import { OneConfig } from '@yy/one-config'
import { sentryReport } from './sentry/report'

export const oneConfig = new OneConfig({
  env: process.env.APP_ENV,
  priority: window.ONE_CDN_SERVER === 'oss' ? ['oss', 's3'] : ['s3', 'oss'],
  onError: sentryReport,
})
